import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/icd-code-concept";

export const pagingICDCodeConcept = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getICDCodeConceptById = (icdCodeConceptId) => axios.get(API_PATH + "/get-by-id/" + icdCodeConceptId);
export const getICDCodeListConceptById = (icdCodeConceptId) => axios.get(API_PATH + "/get-list-by-icd-id/" + icdCodeConceptId);

export const saveICDCodeConcept = icdCodeConcept => axios.post(API_PATH + '/save', icdCodeConcept);
export const saveICDCodeListConcept = icdCodeConcept => axios.post(API_PATH + '/save-icd-code-list-concept', icdCodeConcept);

export const deleteICDCodeConcept = icdCodeConceptId => axios.delete(API_PATH + '/mark-delete/' + icdCodeConceptId)
export const getAllMedicationRequestForm = () => axios.get(API_PATH + "/get-all");
